import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { dateKey } from '../../../shared/lib/format';
import { useWorkspace } from '../../stores';
import { invoicesApi } from '../api/invoicesApi';
export function useInvoiceRange(from: string, to: string, enabled = true) {
  const { isDemo, store, scopeKey, timezone } = useWorkspace(); const demo = useDemo();
  return useQuery({ queryKey: [...scopeKey, 'invoice-range', from, to, isDemo ? demo.revision : 0], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.invoices.filter(i => i.store_id === store?.id && dateKey(i.bill_date_ms, timezone) >= from && dateKey(i.bill_date_ms, timezone) <= to)) : invoicesApi.list(from, to, timezone, signal), enabled: enabled && Boolean(store?.id), staleTime: 30_000 });
}
